import React from 'react'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import AddField from '@/components/addField/AddField'
import ActionButton from '@/components/buttons/ActionButton'
import LoginIcon from '@mui/icons-material/Login'
import { useLazyLoginQuery } from '@/store/apis/auth'

const Login: React.FC = () => {
  const [loginQuery, { isFetching }] = useLazyLoginQuery()
  const { t } = useTranslation('default')
  const navigate = useNavigate()
  const [email, setEmail] = React.useState<string>('')
  const [password, setPassword] = React.useState<string>('')

  const login = async (event: React.SyntheticEvent) => {
    event.preventDefault()
    await loginQuery({ email, password })
    navigate('/schema')
    return false
  }

  return (
    <form onSubmit={login}>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        alignItems="center"
        spacing={3}
      >
        <Grid item>
          <Typography component="h1" align="center">
            {t('login.loginDescription')}
          </Typography>
        </Grid>
        <Grid item>
          <AddField
            label={t('login.email')}
            type="email"
            supressEmptyError
            value={email}
            onChange={(newValue) => setEmail(newValue)}
          />
        </Grid>
        <Grid item>
          <AddField
            label={t('login.password')}
            type="password"
            value={password}
            onChange={(newValue) => setPassword(newValue)}
          />
        </Grid>
        <Grid item>
          <ActionButton
            icon={<LoginIcon />}
            isLoading={isFetching}
            label={t('login.login')}
            onClick={login}
            type="submit"
          />
        </Grid>
        <Grid item>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate('/request-change-password')}
          >
            {t('login.forgotPassword')}
          </Link>
        </Grid>
      </Grid>
    </form>
  )
}

export default Login
